import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { gatherClasses } from "../../lib/utils";
import { DISPLAY_NAME_BODY } from "./constants";
import { PageContext } from "./pageContext";

class PageBody extends PureComponent {
  getBodyClassName() {
    const { tabPresent } = this.context;
    const { header, scrollable, alert } = this.props;
    let bodyClass = `${header ? "oui-with-header" : "oui-without-header"} ${
      !tabPresent ? "oui-no-tabs" : ""
    }`;

    if (!scrollable) {
      bodyClass += " oui-no-scroll";
    }

    if (alert) {
      bodyClass += " oui-with-alert";
    }

    return bodyClass;
  }

  render() {
    const bodyClass = this.getBodyClassName();
    const { dataTestId, children } = this.props;
    return (
      <div
        data-testid={dataTestId}
        className={gatherClasses(this.props, "oui-page-body", bodyClass)}
      >
        {children}
      </div>
    );
  }
}

PageBody.contextType = PageContext;

PageBody.propTypes = {
  header: PropTypes.bool,
  alert: PropTypes.bool,
  scrollable: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  dataTestId: PropTypes.string
};

PageBody.defaultProps = {
  header: true,
  scrollable: true,
  dataTestId: "orion-page-body"
};

PageBody.displayName = DISPLAY_NAME_BODY;

export default PageBody;
